export default "__VITE_ASSET__DzEF$ipa__"